export class WebhookV1StandardPayloadPolicyChangeArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "policyArguments",
            "baseName": "policyArguments",
            "type": "WebhookV1PolicyArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadPolicyChangeArguments.attributeTypeMap;
    }
    constructor() {
    }
}
